module.exports = __webpack_public_path__ + "static/logos-08-db2e1d9d2122e4f29d0d2d6c363d48ae.png";